import { CONTACT_REQUEST_MESSAGES, ContactRequestMessages } from "./contact-request-messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type ContactAddressMessages = ContactRequestMessages &
  PopoverMessages &
  ActionButtonMessages & {
    // Section Titles
    addressSection: string;
    chatSection: string;
    personalDetailsSection: string;
    contactAddressTitle: string;

    // INPUT LABELS: Labels for the input fields in the address section
    addressLabel: string;
    addressNumberLabel: string;
    addressComplLabel: string;
    addressDistrictLabel: string;
    addressCityLabel: string;
    addressStateLabel: string;
    addressStateUfLabel: string;
    addressZipCodeLabel: string;
    addressCountryLabel: string;
    addressNameLabel: string;

    // Table Titles and Column Labels: Titles for the address section and labels for address table columns
    titleAddress: string;
    titleCardAddress: string;
    addressNameColumn: string;
    addressColumn: string;
    addressNumberColumn: string;
    addressComplColumn: string;
    addressDistrictColumn: string;
    addressCityColumn: string;
    addressStateColumn: string;
    addressStateUfColumn: string;
    addressZipCodeColumn: string;
    addressCountryColumn: string;
    optionsColumn: string;

    // Address Options: Options for address-related selections
    addressBrazilOption: string;

    // Popover Messages: Messages for actions related to addresses (like deletion confirmation)
    deleteAddressDialogTitle: string;
    deleteAddressDialogContent: string;
    deleteAddressDialogCancel: string;
    deleteAddressDialogConfirm: string;
    deleteAddressSuccess: string;

    // Validation Error Messages: Error messages for address form validation
    errorRequiredAddress: string;
    errorRequiredAddressName: string;
    errorMaxAddressName: string;
    errorRequiredAddressNumber: string;
    errorRequiredAddressCompl: string;
    errorRequiredAddressDistrict: string;
    errorRequiredAddressCity: string;
    errorRequiredAddressState: string;
    errorRequiredAddressStateUf: string;
    errorRequiredAddressZipCode: string;
    errorRequiredAddressCountry: string;

    // Additional Errors
    cepNotFoundError: string;
  };

export const CONTACT_ADDRESS_MESSAGES: ContactAddressMessages = {
  // Section Titles
  addressSection: "Endereço",
  chatSection: "Mensagens",
  personalDetailsSection: "Informações",
  contactAddressTitle: "Endereço do contato",

  // INPUT LABELS: Labels for address input fields
  addressLabel: "Endereço",
  addressNumberLabel: "Número",
  addressComplLabel: "Complemento",
  addressDistrictLabel: "Bairro",
  addressCityLabel: "Cidade",
  addressStateLabel: "Estado",
  addressStateUfLabel: "UF",
  addressZipCodeLabel: "CEP",
  addressCountryLabel: "País",
  addressNameLabel: "Identificar este endereço como",

  // Table Titles: Titles for the address list in UI
  titleAddress: "Endereço",
  titleCardAddress: "Endereços Adicionais",

  // Column Labels: Labels for columns in the address table
  addressNameColumn: "Nome",
  addressColumn: "Endereço",
  addressNumberColumn: "Número",
  addressComplColumn: "Complemento",
  addressDistrictColumn: "Bairro",
  addressCityColumn: "Cidade",
  addressStateColumn: "Estado",
  addressStateUfColumn: "UF",
  addressZipCodeColumn: "CEP",
  addressCountryColumn: "País",
  optionsColumn: "Opções",

  // Address Options: Options for address fields, like country
  addressBrazilOption: "Brasil",

  // Popover Messages: Texts for actions like deleting an address
  deleteAddressDialogTitle: "Remover Endereço",
  deleteAddressDialogContent: "Tem certeza de que deseja remover este endereço?",
  deleteAddressDialogCancel: "Cancelar",
  deleteAddressDialogConfirm: "Confirmar",
  deleteAddressSuccess: "Endereço removido com sucesso!",

  // Validation Errors: Error messages for address form validation
  errorRequiredAddress: "Digite um endereço",
  errorRequiredAddressName: "O nome do endereço é obrigatório!",
  errorMaxAddressName: "O nome do endereço deve ter no máximo 20 caracteres!", // Nova mensagem
  errorRequiredAddressNumber: "O número do endereço é obrigatório!",
  errorRequiredAddressCompl: "O complemento do endereço é obrigatório!",
  errorRequiredAddressDistrict: "O distrito do endereço é obrigatório!",
  errorRequiredAddressCity: "A cidade do endereço é obrigatória!",
  errorRequiredAddressState: "O estado do endereço é obrigatório!",
  errorRequiredAddressStateUf: "A UF do estado é obrigatória!",
  errorRequiredAddressZipCode: "O CEP do endereço é obrigatório!",
  errorRequiredAddressCountry: "O país do endereço é obrigatório!",
  cepNotFoundError: "Digite um CEP válido",

  // Additional messages included from other sections
  ...POPOVER_MESSAGES,
  ...CONTACT_REQUEST_MESSAGES,

  // ACTION BUTTONS: Labels for action buttons in the address section
  ...ACTION_BUTTON_MESSAGES,
};
